
  const __registry__ = require('../../../../spiferack/client/index.js')
  'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var React = require('react');
var connect = require('../../../components/connect');
var ExpirationDaysInput = require('./expiration-days-input');
var formStyles = require('../../../../shared/styles/forms.css');
var gatStyles = require('../gat.css');
var Input = require('../../../components/inputs/semi-controlled');

var _require = require('./constants'),
    EXPIRATION_DATE_INPUT = _require.EXPIRATION_DATE_INPUT;

var MS_PER_DAY = 1000 * 60 * 60 * 24;

function GATExpiration(props) {
  var formId = props.formId,
      formData = props.formData,
      name = props.name,
      label = props.label,
      onInputChange = props.onInputChange,
      validateSingleInput = props.validateSingleInput;

  var _React$useState = React.useState('30'),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      expirationDays = _React$useState2[0],
      setExpirationDays = _React$useState2[1];

  var _React$useState3 = React.useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      expirationDate = _React$useState4[0],
      setExpirationDate = _React$useState4[1];

  var onExpirationSelect = React.useCallback(function (expirationDays) {
    setExpirationDays(expirationDays);
    setExpirationDate('');

    onInputChange(name, expirationDays);
    props.dispatch({
      type: 'FORM_CHANGE',
      formId: formId,
      name: name,
      value: expirationDays
    });
  }, [expirationDays]);

  var onExpirationDateEntered = React.useCallback(function (date) {
    setExpirationDate(date);
    setExpirationDays('');

    var days = daysTillDate(date).toString();
    onInputChange(name, days);
    props.dispatch({
      type: 'FORM_CHANGE',
      formId: formId,
      name: name,
      value: days
    });
  }, [expirationDate]);

  var inputClassName = gatStyles.inputExpirationDate + ' ' + gatStyles.textInput;
  var labelId = formId + '_expiration_section';
  var errorMessageId = labelId + '_error_message';
  var errorMessage = formData[formId][name].errorMessage;
  var valid = !errorMessage;

  return React.createElement(
    'div',
    { className: gatStyles.inputContainer },
    React.createElement(
      'label',
      { id: labelId, className: gatStyles.inputLabel },
      label
    ),
    React.createElement(
      'div',
      { className: 'flex' },
      React.createElement(ExpirationDaysInput, {
        formId: formId,
        onSelect: onExpirationSelect,
        outerLabelId: labelId,
        ariaDescribedby: errorMessageId
      }),
      expirationDays === '' && React.createElement(Input, {
        type: 'date',
        name: EXPIRATION_DATE_INPUT,
        value: expirationDate,
        min: tomorrowDate(),
        className: inputClassName + ' ' + (valid ? '' : formStyles.invalid) + ' ',
        onChange: function onChange(ev) {
          return onExpirationDateEntered(ev.target.value);
        },
        onBlur: function onBlur() {
          return validateSingleInput(name, formData);
        },
        'aria-labelledby': labelId,
        'aria-describedby': errorMessageId,
        'aria-invalid': !!errorMessage
      })
    ),
    React.createElement(
      'div',
      { className: formStyles.errorMessage, id: errorMessageId },
      errorMessage
    )
  );
}

function daysTillDate(date) {
  var now = new Date();
  var expirationDate = new Date(date);
  var diff = expirationDate.getTime() - now.getTime();
  return Math.ceil(diff / MS_PER_DAY);
}

function tomorrowDate() {
  var today = new Date();
  var tomorrow = new Date(today.getTime() + MS_PER_DAY);
  return tomorrow.toISOString().split('T')[0];
}

module.exports = connect()(GATExpiration);
  let __hot__
  
  __registry__.register('tokens/gat/gat-expiration', module.exports, __hot__)
  